function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCopyright = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "16pt",
  height: 20,
  viewBox: "0 0 16 15"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15.918 7.46c0 4.122-3.563 7.466-7.957 7.466C3.563 14.926 0 11.582 0 7.46S3.563 0 7.96 0c4.395 0 7.958 3.34 7.958 7.46m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#000",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.293 7.46c0 3.282-2.836 5.942-6.332 5.942-3.5 0-6.336-2.66-6.336-5.941 0-3.277 2.836-5.938 6.336-5.938 3.496 0 6.332 2.66 6.332 5.938m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#fff",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.426 7.46c0 2.313-2 4.188-4.465 4.188-2.469 0-4.469-1.875-4.469-4.187s2-4.188 4.469-4.188c2.465 0 4.465 1.875 4.465 4.188m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#000",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.395 7.46c0 1.263-1.09 2.286-2.434 2.286-1.348 0-2.438-1.023-2.438-2.285s1.09-2.285 2.438-2.285c1.344 0 2.434 1.023 2.434 2.285m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#fff",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.34 6.473h3.656v1.902H9.34Zm0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#fff",
    fillOpacity: 1
  }
}));
export { SvgCopyright as ReactComponent };
export default __webpack_public_path__ + "static/media/copyright.f406b81c.svg";